import { useContext } from 'react';
import { createContext } from 'react';

import { MinicartBaseContentProps } from '../@types/MinicartBaseContentProps';

export const MinicartBaseContentContext = createContext<MinicartBaseContentProps>({} as MinicartBaseContentProps);

MinicartBaseContentContext.displayName = 'MinicartBaseContent';

const MinicartBaseContentProvider = (props: MinicartBaseContentProps) => (
	<MinicartBaseContentContext.Provider value={props}>{props.children}</MinicartBaseContentContext.Provider>
);

export const useMinicartBaseContent = () => {
	const context = useContext(MinicartBaseContentContext);

	return context;
};

export default MinicartBaseContentProvider;
